import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";

import { DocumentProvider } from "./Components/DocumentViewPage/context/DocumentContext";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { MsalProvider } from "@azure/msal-react";
import { authConfigErrors, hasRequiredAuthConfig, msalClientBuilder } from "./auth";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import AuthConfigError from "./Components/Auth/AuthConfigError";
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

const msalInstance = hasRequiredAuthConfig ? msalClientBuilder() : null;

root.render(
  <React.StrictMode>
    {hasRequiredAuthConfig && msalInstance ? (
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <DocumentProvider>
            <BrowserRouter>
              <ScrollToTop />
              <App />
            </BrowserRouter>
            {/* {import.meta.env.DEV && (
              <ReactQueryDevtools initialIsOpen={false} />
            )} */}
          </DocumentProvider>
        </QueryClientProvider>
      </MsalProvider>
    ) : (
      <AuthConfigError errors={authConfigErrors} />
    )}
  </React.StrictMode>
);

reportWebVitals();

